export const en = {
  translation: {
    pageTitle: 'OneKey Device Management Tool',
    pageSubtitle: 'Search Devices',
    // 添加头部标题翻译
    header: {
      title: 'OneKey Developer Portal',
      version: 'Version',
    },
    common: {
      device: 'Device',
      chainMethods: 'Signer',
      deviceMethods: 'Device Methods',
      firmware: 'Firmware',
      logs: 'Logs',
      connect: 'Connect',
      shareLog: 'Share Logs',
      features: 'Get Features',
      search: 'Search Devices',
      connection: 'Connection',
      response: 'Response',
      getAddress: 'Get Address',
      getPublicKey: 'Get Public Key',
      signMessage: 'Sign Message',
      signTransaction: 'Sign Transaction',
      noResponse: 'No response data available',
      copy: 'Copy to clipboard',
      networks: 'Networks',
      home: 'Home',
      emulator: 'Emulator',
      navigation: 'Navigation',
      current: 'Current',
      toggleTheme: 'Toggle Theme',
      toggleSidebar: 'Toggle Sidebar',
      docs: 'Documentation',
      ready: 'Ready',
      waiting: 'Waiting',
      explore: 'Explore',
      back: 'Back to List',
      dangerous: 'Dangerous',
      requiresConfirmation: 'Requires Confirmation',
      loading: 'Loading...',
      execute: 'Execute',
      confirm: 'Confirm',
      basicOperations: 'Basic Operations',
      basicOperationsDesc: 'Basic device connection and communication operations',
      cancel: 'Cancel',
      error: 'Error',
      goToHomePage: 'Go to the home page',
      goHome: 'Go Home',
      connecting: 'Connecting',
      connected: 'Connected',
      disconnected: 'Not Connected',
      deviceName: 'Device Name',
      deviceType: 'Device Type',
      uuid: 'UUID',
      connectId: 'Connection ID',
      transport: 'Transport',
      firmwareVersion: 'Firmware Version',
      deviceInfo: 'Device Information',
      bluetoothVersion: 'Bluetooth Version',
      bootVersion: 'Boot Version',
      pinInputSupport: 'PIN Input Support',
      supported: 'Supported',
      notSupported: 'Not Supported',
      edit: 'Edit',
      save: 'Save',
      clear: 'Clear',
      select: 'Select',
      seInfo: 'Device SE Information',
    },
    deviceInfo: {
      deviceInfo: 'Device Information',
      seInfo: 'Device SE Information',
    },
    device: {
      status: 'Device Status',
      connected: 'Connected',
      disconnected: 'Disconnected',
      connecting: 'Connecting...',
      searchDevices: 'Search Devices',
      connectedTo: 'Connected to',
      webusb: 'WebUSB',
      jsbridge: 'JSBridge',
      bluetooth: 'WebBluetooth',
      webUSB: 'WebUSB',
      selectDevice: 'Select Device',
      noDevices: 'No devices found. Please connect a device.',
      scanning: 'Scanning for devices...',
      connectDevice: 'Connect and unlock your device.',
      connectionSuccess: 'Connection successful!',
      connectionError: 'Connection failed. Please try again.',
      connectionMethod: 'Connection Method',
      selectConnection: 'Select Connection Method',
      notSelected: 'Not Selected',
      connection: 'Device Connection',
      ready: 'Ready',
      initializing: 'Initializing',
      waiting: 'Waiting',
      unknown: 'Unknown Device',
      connectionRequired: 'Device Connection Required',
      pleaseConnectFirst: 'Please connect your hardware device before performing operations',
      noActiveConnection: 'No active connection',
      connectOnHomePage: 'Connect your device on the home page to get started',
      bluetoothVersion: 'Bluetooth Version',
      bootVersion: 'Boot Version',
      pinInputSupport: 'PIN Input on Client',
      supported: 'Supported',
      notSupported: 'Not Supported',
      deviceInfo: 'Device Information',
      save: 'Save',
      edit: 'Edit',
      copied: 'Copied',
      clear: 'Clear',
      reset: 'Reset',
      required: 'Required',
      optional: 'Optional',
      success: 'Success',
      failed: 'Failed',
      retry: 'Retry',
      close: 'Close',
      open: 'Open',
      expand: 'Expand',
      collapse: 'Collapse',
      show: 'Show',
      hide: 'Hide',
      enabled: 'Enabled',
      disabled: 'Disabled',
      yes: 'Yes',
      no: 'No',
      all: 'All',
      none: 'None',
      select: 'Select',
      upload: 'Upload',
      download: 'Download',
      file: 'File',
      size: 'Size',
      format: 'Format',
      type: 'Type',
      progress: 'Progress',
      completed: 'Completed',
      pending: 'Pending',
      processing: 'Processing',
      cancelled: 'Cancelled',
      timeout: 'Timeout',
    },
    home: {
      title: 'OneKey Hardware Wallet SDK',
      subtitle: 'Explore and test OneKey hardware wallet SDK functionalities',
      deviceMethods: 'Device Methods',
      deviceMethodsDesc:
        'Access device information, manage settings, and perform device-specific operations',
      chainMethods: 'Signer',
      chainMethodsDesc: 'Interact with different blockchain networks through your OneKey device',
      logs: 'System Logs',
      logsDesc: 'View detailed logs of all device operations and API interactions',
      quickStart: 'Quick Start Guide',
      quickStartDesc: 'Follow these simple steps to get started with OneKey SDK',
      step1: 'Connect your OneKey device via USB or Bluetooth',
      step2: 'Choose a transport method (WebUSB or JSBridge)',
      step3: 'Explore device methods to manage your hardware wallet',
      step4: 'Test chain methods to interact with blockchains',
      security: 'Enterprise Security',
      securityDesc: 'Military-grade security with hardware-based key storage and isolation',
      openSource: 'Open Source',
      openSourceDesc: 'Fully open-source codebase for transparency and community contributions',
      getStarted: 'Ready to Get Started?',
      getStartedDesc: 'Explore OneKey SDK features with your hardware wallet device',
      tryDemo: 'Try Demo Now',
      initializing: 'Initializing',
      waiting: 'Waiting',
      unknown: 'Unknown Device',
      connectionRequired: 'Device Connection Required',
      pleaseConnectFirst: 'Please connect your hardware device before performing operations',
      noActiveConnection: 'No active connection',
      connectOnHomePage: 'Connect your device on the home page to get started',
      connectedVia: 'Connected via {{transport}}',
    },
    signer: {
      btc: 'BTC',
      eth: 'EVM',
      sol: 'SOL',
      path: 'Derivation Path',
      message: 'Message',
      txData: 'Transaction Data',
      deviceInteraction: 'Device Interaction',
      eventLogs: 'Event Logs',
      clearLogs: 'Clear logs',
      noEvents: 'No events recorded yet',
      processing: 'Processing',
      waitingForAction: 'Waiting for action...',
      actionRequired: 'Action Required',
      readyForOperation: 'Ready for operation',
      followInstructions: 'Please follow the instructions on your device',
      confirmAddress: 'Confirm Address',
      signMessage: 'Sign Message',
      reviewTransaction: 'Review Transaction',
      deviceDisplay: 'Device Display',
    },
    deviceMethods: {
      title: 'Device Methods',
      subtitle:
        'Access device information, manage settings, and perform device-specific operations',
      totalMethods: '{{count}} methods',
      totalCategories: '{{count}} categories',
      categories: {
        basic: {
          name: 'Basic Operations',
          description: 'Device connection and basic information',
        },
        device: {
          name: 'Device Management',
          description: 'Device settings and common operations',
        },
        firmware: {
          name: 'Firmware Update',
          description: 'Firmware check, update and reboot operations',
        },
        advanced: {
          name: 'Advanced Features',
          description: 'U2F, verification and dangerous operations',
        },
        basicOperations: {
          name: 'Basic Operations',
          description: 'Device connectivity & info',
        },
        deviceManagement: {
          name: 'Device Management',
          description: 'PIN, settings & security',
        },
        firmwareUpdate: {
          name: 'Firmware Update',
          description: 'Firmware, bootloader & BLE updates',
        },
        releaseInformation: {
          name: 'Release Information',
          description: 'Version checks & release data',
        },
        deviceControl: {
          name: 'Device Control',
          description: 'Reboot & bootloader operations',
        },
      },
    },
    chains: {
      title: 'Blockchain Methods',
      subtitle: 'Interact with different blockchain networks through your OneKey device',
      searchPlaceholder: 'Search blockchains...',
      availableChains: '{{count}} blockchains available',
      methodsCount: '{{count}} methods',
      noResults: 'No blockchains found for "{{searchTerm}}"',
      exploreChain: 'Explore {{chainId}} methods',
    },
    // 添加方法描述翻译
    methodDescriptions: {
      btcGetAddress: 'Get address for your account.',
      btcGetPublicKey: 'Get public key for your account.',
      btcSignMessage: 'Sign a message with your private key.',
      btcSignPsbt: 'Sign a PSBT (Partially Signed Bitcoin Transaction).',
      btcSignTransaction: 'Sign a transaction with your private key.',
      btcVerifyMessage: 'Verify a message signature.',
      alephiumGetAddress: 'Get address for your account.',
      alephiumSignMessage: 'Sign a message with your private key.',
      alephiumSignTransaction: 'Sign a transaction with your private key.',
      algoGetAddress: 'Get address for your account.',
      algoSignTransaction: 'Sign a transaction with your private key.',
      allNetworkGetAddress: 'Get address for your account.',
      aptosGetAddress: 'Get address for your account.',
      aptosGetPublicKey: 'Get public key for your account.',
      aptosSignMessage: 'Sign a message with your private key.',
      aptosSignTransaction: 'Sign a transaction with your private key.',
      benfenGetAddress: 'Get address for your account.',
      benfenGetPublicKey: 'Get public key for your account.',
      benfenSignMessage: 'Sign a message with your private key.',
      benfenSignTransaction: 'Sign a transaction with your private key.',
      cardanoGetAddress: 'Get address for your account.',
      cardanoGetPublicKey: 'Get public key for your account.',
      cardanoSignMessage: 'Sign a message with your private key.',
      cardanoSignTransaction: 'Sign a transaction with your private key.',
      checkAllFirmwareRelease: 'Check all firmware release information',
      checkBLEFirmwareRelease: 'Check BLE firmware release information',
      checkBootloaderRelease: 'Check bootloader release information',
      checkBridgeRelease: 'Check bridge release information',
      checkFirmwareRelease: 'Check firmware release information',
      confluxGetAddress: 'Get address for your account.',
      confluxSignMessage: 'Sign a message with your private key.',
      confluxSignMessageCIP23: 'Sign Message CIP23',
      confluxSignTransaction: 'Sign a transaction with your private key.',
      cosmosGetAddress: 'Get address for your account.',
      cosmosGetPublicKey: 'Get public key for your account.',
      cosmosSignTransaction: 'Sign a transaction with your private key.',
      deviceCancel: 'Cancel device operation',
      deviceChangePin: 'Change pin of a device',
      deviceLock: 'Lock device',
      deviceRebootToBoardloader: 'Reboot to boardloader mode(pro & touch only)',
      deviceRebootToBootloader: 'Reboot device to bootloader mode',
      deviceSettings: 'Configure device settings',
      deviceSupportFeatures: 'Check device support features',
      deviceUpdateBootloader: 'Update device bootloader',
      deviceVerify: 'Verify device authenticity',
      deviceWipe: 'Wipe device(DANGER: This will erase all data)',
      dnxGetAddress: 'Get address for your account.',
      dnxSignTransaction: 'Sign a transaction with your private key.',
      evmGetAddress: 'Get a EVM address for your account.',
      evmGetPublicKey: 'Get a EVM public key for your account.',
      evmSignMessage: 'Sign a message with your EVM account.',
      evmSignMessageEIP712:
        'Sign a message with your EVM account. \nClassic and Mini firmware versions greater than 2.1.8 and less than 2.2.0 are available',
      evmSignTransaction: 'Sign a transaction with your EVM account.',
      evmSignTypedData: 'Sign a typed data with your EVM account.',
      evmVerifyMessage: 'Verify a message with your EVM account.',
      filecoinGetAddress: 'Get address for your account.',
      filecoinSignTransaction: 'Sign a transaction with your private key.',
      firmwareUpdateV2: 'compatible with all devices',
      firmwareUpdateV3: 'pro deivce & bootloader > 4.12.0 only',
      getFeatures: 'Get features of a device',
      getLogs: 'Get device logs',
      getNextU2FCounter: 'Get next U2F counter value',
      getOnekeyFeatures: 'Get OneKey specific features of a device',
      getPassphraseState: 'Get passphrase state of a device',
      kaspaGetAddress: 'Get address for your account.',
      kaspaSignTransaction: 'Sign a transaction with your private key.',
      lnurlAuth: 'LNURL Auth',
      nearGetAddress: 'Get address for your account.',
      nearSignTransaction: 'Sign a transaction with your private key.',
      nemGetAddress: 'Get address for your account.',
      nemSignTransaction: 'Sign a transaction with your private key.',
      neoGetAddress: 'Get address for your account.',
      neoSignTransaction: 'Sign a transaction with your private key.',
      nervosGetAddress: 'Get address for your account.',
      nervosSignTransaction: 'Sign a transaction with your private key.',
      nexaGetAddress: 'Get address for your account.',
      nexaSignTransaction: 'Sign a transaction with your private key.',
      nostrDecryptMessage: 'Decrypt message',
      nostrEncryptMessage: 'Encrypt message',
      nostrGetPublicKey: 'Get a Nostr public key for your account.',
      nostrSignEvent: 'Sign a Nostr event.',
      nostrSignSchnorr: 'Sign schnorr',
      polkadotGetAddress: 'Get address for your account.',
      polkadotSignTransaction: 'Sign a transaction with your private key.',
      scdoGetAddress: 'Get address for your account.',
      scdoSignMessage: 'Sign a message with your private key.',
      scdoSignTransaction: 'Sign a transaction with your private key.',
      searchDevices: 'Search for devices',
      setU2FCounter: 'Set U2F counter value',
      solGetAddress: 'Get address for your account.',
      solSignMessage: 'Sign a message with your private key.',
      solSignOffchainMessage: 'Sign Offchain Message',
      solSignTransaction: 'Sign a transaction with your private key.',
      starcoinGetAddress: 'Get address for your account.',
      starcoinGetPublicKey: 'Get public key for your account.',
      starcoinSignMessage: 'Sign a message with your private key.',
      starcoinSignTransaction: 'Sign a transaction with your private key.',
      starcoinVerifyMessage: 'Verify a message signature.',
      stellarGetAddress: 'Get address for your account.',
      stellarSignTransaction: 'Sign a transaction with your private key.',
      suiGetAddress: 'Get address for your account.',
      suiGetPublicKey: 'Get public key for your account.',
      suiSignMessage: 'Sign a message with your private key.',
      suiSignTransaction: 'Sign a transaction with your private key.',
      tonGetAddress: 'Get address for your account.',
      tonSignMessage: 'Sign a message with your private key.',
      tonSignProof: 'Sign Proof',
      tronGetAddress: 'Get address for your account.',
      tronSignMessage: 'Sign a message with your private key.',
      tronSignTransaction: 'Sign a transaction with your private key.',
      xrpGetAddress: 'Get address for your account.',
      xrpSignTransaction: 'Sign a transaction with your private key.',
    },
    deviceOperations: {
      deviceStatus: {
        title: 'Device Status',
        description: 'Check the current status and features of your device',
      },
      firmware: {
        title: 'Firmware',
        description: 'Check for firmware and manage device software',
      },
      passphraseStatus: {
        title: 'Passphrase Status',
        description: 'Check and manage passphrase protection on your device',
      },
      deviceVerification: {
        title: 'Device Verification',
        description: 'Verify the authenticity of your OneKey device',
      },
      configTitle: 'Operation Configuration',
      requestParams: 'Request Parameters',
      autoFilled: 'Auto-filled',
      showAdvanced: 'Show Advanced Options',
      hideAdvanced: 'Hide Advanced Options',
      timeout: 'Request Timeout',
      developerTools: 'Developer Tools',
      execute: 'Execute',
      cancel: 'Cancel',
      cancelOperation: 'Cancel Operation',
      restart: 'Restart',
      backToList: 'Back to List',
      executionStatus: 'Execution Status',
      deviceInteraction: 'Device Interaction',
      waitForDevice: 'Waiting for device...',
      deviceInstructions:
        'Please follow the instructions on your device to complete the operation.',
      errorDetails: 'Error Details',
      errorCode: 'Error Code',
      possibleSolutions: 'Possible Solutions',
      solutions: {
        confirmOnDevice: 'Make sure to confirm the action on your device',
        ensureUnlocked: 'Ensure your device is unlocked',
        checkConnection: 'Check your device connection',
      },
      responseData: 'Response Data',
      operationLogs: 'Operation Logs',
      clearLogs: 'Clear Logs',
      noLogs: 'No logs available',
      executionId: 'Execution ID',
      status: {
        ready: 'Ready to execute',
        preparing: 'Preparing request',
        completed: 'Request completed',
        deviceInteraction: 'Interacting with device',
        deviceInteractionCompleted: 'Device interaction completed',
        deviceInteractionFailed: 'Device interaction failed',
        success: 'Operation successful',
        failed: 'Operation failed',
        completion: 'Completion',
      },
      errors: {
        timeout: 'Operation timed out',
        canceled: 'Operation canceled by user',
        unknown: 'Unknown error occurred',
      },
      logMessages: {
        requestSent: 'Request sent: {{operation}}',
        timeout: 'Operation timed out',
        waitingForDevice: 'Waiting for device response...',
        operationCompleted: 'Operation completed successfully',
        operationFailed: 'Operation failed: {{error}}',
        exception: 'Exception occurred: {{error}}',
        operationCanceled: 'Operation canceled by user',
      },
    },
    logs: {
      title: 'System Logs',
      clear: 'Clear Logs',
      time: 'Time',
      type: 'Type',
      message: 'Message',
      noLogsToShare: 'No logs to share',
      records: 'records',
      searchPlaceholder: 'Search logs by content, type, or message...',
      noLogs: 'No Operation Logs',
      noLogsDesc: 'Connect your device and perform operations to see logs here',
      executeOperation: 'Execute Operation',
      deviceLogs: 'Device Operation Logs',
      deviceLogsDesc:
        'Display recent device operation records, including connections, signatures and error messages',
      configuration: 'Configuration',
      cleanupExpired: 'Cleanup Expired',
      exportJson: 'Export JSON',
      exportText: 'Export Text',
      storageConfig: {
        title: 'Log Storage Configuration',
        description:
          'Configure log storage policies including size limits, expiration time and compression settings',
        maxEntries: 'Max Entries',
        expirationDays: 'Expiration Days',
        maxSizeMb: 'Max Size (MB)',
        enableCompression: 'Enable Compression',
        reset: 'Reset',
        save: 'Save',
      },
      stats: {
        totalEntries: 'Total Entries',
        storageSize: 'Storage Size',
        oldestRecord: 'Oldest Record',
        newestRecord: 'Newest Record',
        none: 'None',
      },
      exportMessages: {
        success: 'Export successful',
        successDesc: 'Exported {{count}} log records',
        failed: 'Export failed',
        noLogs: 'No logs to export',
        error: 'An error occurred during export',
      },
      cleanup: {
        completed: 'Cleanup completed',
        completedDesc: 'Cleaned up {{count}} expired logs',
      },
      config: {
        saved: 'Configuration saved',
        savedDesc: 'Log storage configuration updated',
      },
    },
    logDisplay: {
      title: 'Device Logs',
      filterAll: 'All Logs',
      filterInfo: 'Info',
      filterError: 'Errors',
      filterRequest: 'Requests',
      filterResponse: 'Responses',
      clear: 'Clear Logs',
      noLogs: 'No logs available',
    },
    dashboard: {
      title: 'OneKey Developer Dashboard',
      deviceInfo: 'Device Information',
      connectId: 'Connection ID',
      deviceType: 'Device Model',
      deviceConnected: 'Device Connected Successfully',
      deviceInstructions:
        'You can now use the device features below to interact with your OneKey device.',
    },
    pin: {
      title: 'Enter PIN',
      instruction: 'Enter your device PIN',
      enterPin: 'Enter PIN',
      enterPinWeb: 'Enter PIN on Web',
      webInputInstruction:
        'Your device supports secure PIN input on the web, which is more convenient and faster',
      webSubmit: 'Web Confirm',
      confirmPin: 'Confirm PIN',
      pinRequired: 'PIN is required for this operation',
      incorrectPin: 'Incorrect PIN, please try again',
      cancel: 'Cancel',
      submit: 'Submit',
      deviceInput: 'Use device input',
      webInput: 'Use web input',
      checkDeviceLayout: 'Please check the keyboard layout on your device screen.',
    },
    passphrase: {
      title: 'Enter Passphrase',
      instruction: 'Enter your device passphrase (optional)',
      enterPassphrase: 'Enter Passphrase',
      confirmPassphrase: 'Confirm Passphrase',
      passphraseOptional: 'Passphrase is optional for additional security',
      enablePassphrase: 'Enable passphrase protection',
      disablePassphrase: 'Disable passphrase protection',
      cancel: 'Cancel',
      submit: 'Submit',
      deviceInput: 'Use device input',
      webInput: 'Use web input',
      showPassphrase: 'Show passphrase',
      hidePassphrase: 'Hide passphrase',
      passphraseInfo: 'Passphrase adds an extra layer of security to your wallet',
      placeholder: 'Enter passphrase',
      confirmPlaceholder: 'Re-enter passphrase',
      saveToSession: 'Keep accessible. Hidden wallets remain after closing the app',
      inputOnDevice: 'Enter on device',
      useDevice: 'Use device input',
      deviceInputDescription: 'Passphrase will be securely entered on device',
      webInputDescription: 'Enter passphrase on web to continue',
      warningMessage: 'Lost passphrase cannot be recovered',
      maxLength: 'Maximum 50 characters',
    },
    transport: {
      webusb: {
        description: 'Recommended',
        deviceConnected: 'WebUSB device connected successfully',
        noDeviceSelected: 'No device selected',
        notSupported: 'WebUSB is not supported in this browser',
      },
      jsbridge: {
        description: 'Stable compatibility',
      },
      emulator: {
        description: 'Development testing',
      },
      webble: {
        description: 'Bluetooth',
      },
      comingSoon: 'Coming soon',
      sdkNotReady: 'SDK not ready',
      pleaseWaitForInit:
        'Please wait for SDK initialization to complete before switching transport methods',
      switchFailed: 'Failed to switch transport method',
      connectionFailed: 'Connection failed',
      connectionSuccessful: 'Connection successful',
      noDevicesFound: 'No devices found',
      ensureDeviceConnected: 'Please ensure the device is connected and unlocked',
      searchFailed: 'Search failed',
      searchDeviceFailed: 'Failed to search for devices',
      connectionTip: 'Connection tip',
      unknownConnectionError: 'Unknown error occurred during connection',
      needsBridge: 'Requires',
      downloadBridge: 'Download Bridge',
      needsEmulator: 'Requires',
      startEmulator: 'Start emulator',
      sdkInitializing: 'Initializing...',
      sdkInitError: 'SDK initialization failed',
    },
    sdk: {
      browserRequired: 'Browser environment required',
      initError: 'SDK initialization failed',
      initFailed: 'Initialization failed: {{error}}',
    },
    firmware: {
      webusb: {
        authorize: {
          title: 'Authorize WebUSB',
          description:
            'Your device switched to bootloader mode to apply the update. Chrome treats this as a new USB device. Please authorize it to continue the firmware update.',
          tip: 'Ensure your device is connected. If the chooser doesn\'t appear, try a different USB port or reconnect the cable.',
          selectButton: 'Select Device',
          selecting: 'Selecting...',
          troubleshooting:
            'If you close this dialog or dismiss the chooser, the update will pause. Reopen this dialog to continue when ready.',
        },
      },
    },
    search: {
      sections: {
        interface: 'Interface Control',
        navigation: 'Navigation',
        documentation: 'Documentation',
        external: 'External',
        blockchains: 'Blockchains',
        deviceMethods: 'Device Methods',
        chainMethods: 'Chain Methods',
      },
      actions: {
        toggleSidebar: 'Toggle Sidebar',
        lightTheme: 'Light Theme',
        darkTheme: 'Dark Theme',
        home: 'Home',
        emulator: 'Hardware Emulator',
        logs: 'Logs',
        deviceMethods: 'Device',
        chains: 'Signer',
        githubRepo: 'GitHub Repository',
        githubIssues: 'GitHub Issues',
        githubReleases: 'GitHub Releases',
        onekeyDocs: 'OneKey Documentation',
        onekeyWebsite: 'OneKey Website',
        hardwareConnect: 'Hardware Connect Guide',
      },
      descriptions: {
        emulator: 'Start hardware emulator using Docker',
        logs: 'View operation logs and debug information',
        deviceMethods: 'Hardware device management and firmware update related API methods',
        chains: 'Supported blockchains and related methods',
        githubRepo: 'OneKey Hardware JS SDK source code repository',
        githubIssues: 'Report issues or view known problems',
        githubReleases: 'View release history and changelog',
        onekeyDocs: 'OneKey official development documentation',
        onekeyWebsite: 'OneKey official website',
        hardwareConnect: 'Hardware device connection guide',
      },
      keywords: {
        sidebar: 'sidebar toggle display hide',
        theme: 'theme light dark bright',
        home: 'home main page',
        emulator: 'emulator hardware docker',
        logs: 'logs debug',
        device: 'device methods firmware update api',
        chains: 'blockchain signer',
        github: 'github repository source code',
        issues: 'github issues bug report feedback',
        releases: 'github releases changelog version',
        docs: 'documentation docs onekey development',
        website: 'website onekey official',
        connect: 'hardware connect guide tutorial',
      },
      sortModes: {
        priority: 'By Priority',
        alphabetical: 'Alphabetical',
        section: 'By Section',
      },
      placeholder: 'Search',
      inputPlaceholder: 'Search methods and blockchains...',
      navigate: 'Navigate',
      select: 'Select',
      close: 'Close',
    },
    emulator: {
      title: 'Hardware Emulator',
      subtitle: 'Use Docker to quickly start OneKey hardware emulator for development testing',
      hero: {
        title: 'Test Hardware Wallets Without Physical Devices',
        subtitle: 'Start coding in under 5 minutes',
        promise: 'Quick Setup • No Hardware Required • Full Functionality',
      },
      flow: {
        browser: 'Browser',
        docker: 'Docker',
        virtual: 'Virtual Device',
        app: 'Your App',
      },
      progressTitle: 'Setup Progress',
      steps: {
        title: 'Simple 3-Step Process',
        subtitle: 'Get your emulator running in minutes',
        setup: {
          title: 'Download Scripts',
          description: 'Clone the emulator repository',
          longDescription:
            'First, we need to download the emulator setup scripts. This repository contains all the Docker configurations and startup scripts needed to run OneKey hardware emulators.',
        },
        device: {
          title: 'Choose Device',
          description: 'Select device type to emulate',
        },
        launch: {
          title: 'Launch Emulator',
          description: 'Start your chosen emulator',
        },
        connect: {
          title: 'Connect to App',
          description: 'Ready for development',
        },
      },
      step1: {
        title: 'Download Scripts',
        description: 'Clone the emulator repository with one command',
      },
      step2: {
        title: 'Choose Device',
        description: 'Select OneKey Pro or Classic 1s emulator',
      },
      step3: {
        title: 'Start Coding',
        description: 'Connect to your app and start development',
      },
      devices: {
        pro: {
          description: 'Full-featured hardware wallet with touchscreen',
        },
        classic: {
          description: 'Essential hardware wallet with button interface',
        },
      },
      device: {
        pro: {
          description: 'Full-featured hardware wallet with touchscreen',
        },
        classic: {
          description: 'Essential hardware wallet with button interface',
        },
      },
      quickStart: 'Quick Start',
      cloneRepo: 'Clone Git Repository',
      cloneRepository: 'Clone Repository',
      startEmulator: 'Start Emulator',
      connectToApp: 'Connect to Application',
      downloadScript: 'Download emulator script',
      scriptDescription: 'Contains one-click startup scripts for all platforms',
      startCommands: 'Start',
      selectMode: 'Choose your preferred connection mode',
      launchingDevice: 'Launching',
      selectLaunchMode: 'Choose your preferred launch mode below',
      recommended: 'Recommended',
      copied: 'Copied!',
      copiedDesc: 'Command copied to clipboard',
      copyFailed: 'Failed to copy command',
      copyFailedDesc: 'Unable to copy to clipboard',
      copyCommand: 'Copy Command',
      congratulations: 'Congratulations!',
      emulatorReady: 'Your emulator is ready for development',
      nextSteps: 'Next Steps',
      vncMode: 'VNC Mode',
      vncDescription: 'For all platforms, access http://localhost:6088/vnc.html after startup',
      x11Mode: 'X11 Mode',
      x11Description: 'Linux only, native window display',
      connectionInstructions: 'Switch connection method on homepage',
      connectionSteps: {
        step1: 'Return to homepage, select "Emulator" transport method in connection settings',
        step2: 'Click connect button, system will automatically detect running emulators',
        step3: 'Start using full hardware wallet functionality for development testing',
      },
      developmentResources: 'Development Resources',
      resourcesDescription: 'Helpful links and documentation for development',
      gitRepo: 'Git Repository',
      gitRepoDesc: 'Source code and setup scripts',
      documentation: 'Detailed Documentation',
      docDesc: 'Complete development guide',
      comingSoon: 'Coming soon',
      docInProgress: 'Documentation in progress',
      docInProgressDesc: 'Detailed documentation will be released soon, stay tuned',
      vncModeNote:
        'Cross-platform universal, access emulator interface through browser, no additional configuration required',
      x11ModeNote: 'Linux exclusive, native window display, better performance',
      stepProgress: 'Step {{current}} of {{total}}',
      launchVncMode: 'Launch VNC Mode',
      launchX11Mode: 'Launch X11 Mode',
      copyAndRunHint: 'Copy and run one of the commands above to start your emulator',
      connectStep1Title: 'Access Emulator UI',
      connectStep1Desc: 'VNC mode, view in browser',
      connectStep1Action: 'Open localhost:6088',
      connectStep2Title: 'Switch Connection',
      connectStep2Desc: 'Select emulator transport on homepage',
      connectStep2Action: 'Go to Homepage',
      connectStep3Title: 'Start Development',
      connectStep3Desc: 'Use full hardware wallet features for development and testing',
    },
    components: {
      deviceConnectionAlert: {
        defaultMessage: 'Please connect your hardware device before performing operations',
      },
      collapsibleJsonViewer: {
        copied: 'Copied',
        copyFailed: 'Copy failed',
        copyToClipboard: 'Content copied to clipboard',
        cannotCopyToClipboard: 'Cannot copy to clipboard',
        objectCopied: 'Object copied to clipboard',
        arrayCopied: 'Array copied to clipboard',
        items: 'items',
      },
      executionPanel: {
        requestParameters: 'Request Parameters',
        executionLogs: 'Execution Logs',
        copySuccess: 'Copy successful',
        copySuccessDesc: 'Request parameters copied to clipboard',
        copyFailed: 'Copy failed',
        copyFailedDesc: 'Cannot copy to clipboard',
      },
      firmwareFileUpload: {
        clickToSelect: 'Click to select file or drag file here',
        supportedFormats: 'Supported formats',
        maxSize: 'Max',
        fileSizeTooLarge: 'File size exceeds limit',
        unsupportedFormat: 'Unsupported file format. Supported formats',
        firmwareFile: 'Firmware File',
        firmwareDesc: 'Main firmware program file for updating device core functions',
        bootloaderFile: 'Bootloader File',
        bootloaderDesc: 'Boot program file for updating device startup program',
        bleFile: 'BLE Firmware File',
        bleDesc: 'Bluetooth Low Energy firmware file for updating Bluetooth functionality',
        resourceFile: 'Resource File',
        resourceDesc:
          'Device interface resource package containing icons, fonts and other UI elements',
        selectFile: 'Select file...',
        helpInfo: {
          line1:
            '• Ensure firmware files are from reliable sources, avoid using unverified firmware',
          line2: '• Do not disconnect device or close browser during update process',
          line3: '• Recommend backing up important data before updating',
        },
      },
      jsonEditor: {
        editJsonContent: 'Edit JSON Content',
        jsonContent: 'JSON Content',
        enterJsonData: 'Please enter JSON formatted data...',
        jsonFormatError: 'JSON format is incorrect, please check syntax',
        noData: 'No data available',
      },
      listBoundary: {
        preparingData: 'Preparing data...',
        dataNotFound: 'Data Not Found',
        noDataAvailable: 'No data available.',
      },
      methodExecuteBoundary: {
        loadingMethod: 'Loading Method',
        preparingExecution: 'Preparing method execution...',
        methodNotFound: 'Method Not Found',
        methodNotFoundDesc: 'The requested method could not be found.',
        loadingDefault: 'Loading...',
      },
      methodExecutor: {
        deviceNotConnected: 'Device not connected',
        connectDeviceFirst: 'Please connect hardware device first',
        expectedUserExperience: 'Expected User Experience:',
        deviceConnected: 'Device connected, ready to execute',
        connectDevice: 'Please connect device',
        executing: 'Executing...',
        executionSuccess: 'Execution successful',
        executionFailed: 'Execution failed',
        waitingExecution: 'Waiting for execution',
        executing2: 'Executing',
        cancelling: 'Cancelling',
      },
      parameterInput: {
        quickPresets: 'Quick Presets',
        selectPreset: 'Select preset configuration',
        commonParameters: 'Common Parameters',
        methodParameters: 'Method Parameters',
        useEmptyPassphrase: 'useEmptyPassphrase',
        useEmptyPassphraseDesc: 'Use empty passphrase',
        usePassphraseState: 'Use passPhraseState',
        usePassphraseStateDesc: 'Saved passphrase state string in device',
        currentlyNoPassphraseState: 'Currently no passphraseState',
        parametersInBundle: 'Parameters configured in bundle array',
        noAdditionalParams: 'No additional parameters needed',
        selectPresetFirst: 'Please select preset configuration first',
        batchMode: 'Batch Mode:',
        batchModeDesc:
          'Method parameters are in bundle array, outer layer only retains common parameters.',
        selectFirmwareFile: 'Select {{title}}...',
        firmwareFileHelp: {
          line1:
            '• Ensure firmware files are from reliable sources, avoid using unverified firmware',
          line2: '• Do not disconnect device or close browser during update process',
          line3: '• Recommend backing up important data before updating',
        },
        passphraseState: 'PassphraseState',
        passphraseStateDesc: 'Use passphraseState for hidden wallet',
        deriveCardano: 'deriveCardano',
        deriveCardanoDesc: 'Enable Cardano address derivation',
      },
      unifiedLogger: {
        executionLogs: 'Execution Logs',
        records: 'records',
        searchLogs: 'Search logs...',
        all: 'All',
        request: 'Request',
        response: 'Response',
        hardware: 'Hardware',
        info: 'Info',
        noLogs: 'No log records',
        noMatchingLogs: 'No matching logs',
        logsCopied: 'Copied',
        logsCopiedDesc: 'Log content copied to clipboard',
        copyLogsFailed: 'Copy failed',
        copyLogsFailedDesc: 'Cannot copy to clipboard',
        lines: 'lines',
        expandLines: 'Expand ({{count}} lines)',
        collapseLines: 'Collapse ({{count}} lines)',
        scrollToTop: 'Scroll to top',
      },
      deviceInteractionArea: {
        transferringData: 'Transferring Data',
        transferringDataDesc: 'Transferring firmware data to device...',
        installingFirmware: 'Installing Firmware',
        installingFirmwareDesc: 'Installing firmware, please do not disconnect device...',
      },
      webusb: {
        authorize: {
          title: 'Authorize WebUSB',
          description:
            'Your device switched to bootloader mode to apply the update. Chrome treats this as a new USB device. Please authorize it to continue the firmware update.',
          tip: 'Ensure your device is connected. If the chooser doesn’t appear, try a different USB port or reconnect the cable.',
          selectButton: 'Select Device',
          selecting: 'Selecting...',
          troubleshooting:
            'If you close this dialog or dismiss the chooser, the update will pause. Reopen this dialog to continue when ready.',
        },
      },
    },
  },
};

export default en;
